import Rest from '../Rest'

export default class CancellationRequestService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/cancellation_requests'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  stats() {
    return this.get('/stats')
  }

  indexStats() {
    return this.get('/index_stats')
  }

  detail(id: number) {
    return this.get(`/${id}/detail`)
  }

  approve(id: number) {
    return this.post(`/${id}/approve`, {})
  }

  deny(id: number, justification: string = '') {
    return this.post(`/${id}/deny`, { justification })
  }

  respond(id: number, message: string, keepDecision: boolean = true) {
    return this.post(`/${id}/respond`, { message, keep_decision: keepDecision })
  }

  decide(id: number, data: any) {
    return this.post(`/${id}/decide`, data)
  }

  clubCancelImpact(data: any) {
    return this.post('/club_cancel/impact', data)
  }

  clubCancelExecute(data: any) {
    return this.post('/club_cancel', data)
  }
}
